import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type MarketItemFragment = { __typename?: 'Market', name: string, id: string, availableViewModes: Array<Types.CompanyViewType>, companyStatus: Types.BrokerMarketStatus };

export type WithAdminCompanyFragment = { __typename?: 'Market', adminCompany?: { __typename?: 'AdminCompany', id: string, name: string } | null };

export type MarketTreeQueryVariables = Types.Exact<{
  withAdminCompany?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type MarketTreeQuery = { __typename?: 'Query', carriers: { __typename?: 'Markets', list: Array<{ __typename?: 'Market', name: string, id: string, availableViewModes: Array<Types.CompanyViewType>, companyStatus: Types.BrokerMarketStatus, children: Array<{ __typename?: 'Market', name: string, id: string, availableViewModes: Array<Types.CompanyViewType>, companyStatus: Types.BrokerMarketStatus, children: Array<{ __typename?: 'Market', name: string, id: string, availableViewModes: Array<Types.CompanyViewType>, companyStatus: Types.BrokerMarketStatus, adminCompany?: { __typename?: 'AdminCompany', id: string, name: string } | null }>, adminCompany?: { __typename?: 'AdminCompany', id: string, name: string } | null }>, adminCompany?: { __typename?: 'AdminCompany', id: string, name: string } | null }> }, intermediaries: { __typename?: 'Markets', list: Array<{ __typename?: 'Market', name: string, id: string, availableViewModes: Array<Types.CompanyViewType>, companyStatus: Types.BrokerMarketStatus, children: Array<{ __typename?: 'Market', name: string, id: string, availableViewModes: Array<Types.CompanyViewType>, companyStatus: Types.BrokerMarketStatus, children: Array<{ __typename?: 'Market', name: string, id: string, availableViewModes: Array<Types.CompanyViewType>, companyStatus: Types.BrokerMarketStatus, adminCompany?: { __typename?: 'AdminCompany', id: string, name: string } | null }>, adminCompany?: { __typename?: 'AdminCompany', id: string, name: string } | null }>, adminCompany?: { __typename?: 'AdminCompany', id: string, name: string } | null }> } };

export const MarketItemFragmentDoc = gql`
    fragment MarketItem on Market {
  name
  id
  availableViewModes
  companyStatus
}
    `;
export const WithAdminCompanyFragmentDoc = gql`
    fragment WithAdminCompany on Market {
  adminCompany {
    id
    name
  }
}
    `;
export const MarketTreeDocument = gql`
    query MarketTree($withAdminCompany: Boolean = false) {
  carriers: markets {
    list(viewMode: ULTIMATE_PARENT_CARRIER) {
      ...MarketItem
      ...WithAdminCompany @include(if: $withAdminCompany)
      children(viewMode: PARENT_CARRIER) {
        ...MarketItem
        ...WithAdminCompany @include(if: $withAdminCompany)
        children(viewMode: ISSUING_PAPER) {
          ...MarketItem
          ...WithAdminCompany @include(if: $withAdminCompany)
        }
      }
    }
  }
  intermediaries: markets {
    list(viewMode: ULTIMATE_PARENT_INTERMEDIARY) {
      ...MarketItem
      ...WithAdminCompany @include(if: $withAdminCompany)
      children(viewMode: PARENT_INTERMEDIARY) {
        ...MarketItem
        ...WithAdminCompany @include(if: $withAdminCompany)
        children(viewMode: INTERMEDIARY) {
          ...MarketItem
          ...WithAdminCompany @include(if: $withAdminCompany)
        }
      }
    }
  }
}
    ${MarketItemFragmentDoc}
${WithAdminCompanyFragmentDoc}`;

/**
 * __useMarketTreeQuery__
 *
 * To run a query within a React component, call `useMarketTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketTreeQuery({
 *   variables: {
 *      withAdminCompany: // value for 'withAdminCompany'
 *   },
 * });
 */
export function useMarketTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MarketTreeQuery, MarketTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MarketTreeQuery, MarketTreeQueryVariables>(MarketTreeDocument, options);
      }
export function useMarketTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MarketTreeQuery, MarketTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MarketTreeQuery, MarketTreeQueryVariables>(MarketTreeDocument, options);
        }
// @ts-ignore
export function useMarketTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MarketTreeQuery, MarketTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarketTreeQuery, MarketTreeQueryVariables>;
export function useMarketTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarketTreeQuery, MarketTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarketTreeQuery | undefined, MarketTreeQueryVariables>;
export function useMarketTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarketTreeQuery, MarketTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MarketTreeQuery, MarketTreeQueryVariables>(MarketTreeDocument, options);
        }
export type MarketTreeQueryHookResult = ReturnType<typeof useMarketTreeQuery>;
export type MarketTreeLazyQueryHookResult = ReturnType<typeof useMarketTreeLazyQuery>;
export type MarketTreeSuspenseQueryHookResult = ReturnType<typeof useMarketTreeSuspenseQuery>;
export type MarketTreeQueryResult = Apollo.QueryResult<MarketTreeQuery, MarketTreeQueryVariables>;